import { assistantOwnerId, canvasToScreen, isAssistantId } from "@worktools/shared";
import { useUi } from "../state/ui";
import { useBoard } from "../sync/BoardContext";
import { useAwarenessStates } from "../sync/hooks";

/** Assistants carry the name of the person who connected them. */
function labelFor(user: { id: string; name: string; ownerName?: string }, meId: string): string {
  if (!isAssistantId(user.id)) return user.name;
  return assistantOwnerId(user.id) === meId ? "Dein Claude" : `Claude · ${user.ownerName ?? "?"}`;
}

export function Cursors() {
  const camera = useUi((state) => state.camera);
  const states = useAwarenessStates();
  const { me } = useBoard();

  return (
    <>
      {states.map((state) =>
        state.cursor ? (
          <div
            key={state.clientId}
            className="cursor"
            style={{ transform: `translate(${canvasToScreen(state.cursor, camera).x}px, ${canvasToScreen(state.cursor, camera).y}px)` }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill={state.user.color}>
              <path d="M5 2.5l13 8.2-5.6 1.3-2.2 5.4z" stroke="white" strokeWidth="1.2" />
            </svg>
            <div className="cursor__name" style={{ background: state.user.color }}>
              {labelFor(state.user as never, me.id)}
            </div>
          </div>
        ) : null,
      )}
    </>
  );
}
